<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="bg-background-100 flex flex-col gap-4 p-8">
  <p>
    Sind Sie sicher, dass Sie <span class="font-bold">{{ username }}</span> löschen möchten?
  </p>
  <p>Hinweis: Die zugewiesenen Vorgänge bleiben bestehen.</p>

  <div class="flex justify-between">
    <odc-cancel-dialog-button data-test-id="dialog-cancel-button-host" />
    <odc-button-with-spinner
      [stateResource]="deleteUserStateResource"
      (clicked)="delete.emit()"
      variant="primary"
      text="Löschen"
      dataTestId="dialog-delete"
      data-test-id="dialog-delete-button-host"
    />
  </div>
</div>
